import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { AlertCircle, Plus, CheckCircle } from 'lucide-react';
import RetroactiveModal from './demandes/RetroactiveModal';

export default function SaisieRetroactive() {
  const [employes, setEmployes] = useState([]);
  const [selectedEmploye, setSelectedEmploye] = useState('');
  const [selectedEmployeNom, setSelectedEmployeNom] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => { fetchEmployes(); }, []);

  const fetchEmployes = async () => {
    try { const res = await api.get('/employes'); setEmployes(res.data.employes || []); }
    catch (err) {}
  };

  const handleSelectEmploye = (e) => {
    const id = e.target.value;
    setSelectedEmploye(id);
    const emp = employes.find(emp => emp.ID_Employes == id);
    setSelectedEmployeNom(emp ? `${emp.Prenom} ${emp.Nom}` : '');
  };

  const handleOpenModal = () => {
    if (!selectedEmploye) return;
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSuccess = () => {
    setShowModal(false);
    setMessage({ type: 'success', text: `✅ Congé rétroactif enregistré pour ${selectedEmployeNom}` });
    setSelectedEmploye('');
    setSelectedEmployeNom('');
    setTimeout(() => setMessage({ type: '', text: '' }), 4000);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800">📅 Saisie rétroactive</h2>
          <p className="text-sm text-gray-500 mt-1">Enregistrer les congés déjà pris avant la mise en place du logiciel</p>
        </div>

        <div className="bg-amber-50 rounded-xl p-4 border border-amber-200 mb-6">
          <div className="flex items-start gap-3">
            <AlertCircle size={20} className="text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-amber-800">Mode saisie rétroactive</p>
              <p className="text-xs text-amber-600 mt-1">Les demandes créées ici seront automatiquement approuvées et déduites du solde.</p>
            </div>
          </div>
        </div>

        {message.text && (
          <div className={`mb-4 p-3 rounded-lg flex items-center gap-2 ${message.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
            <CheckCircle size={16} />{message.text}
          </div>
        )}

        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">👤 Sélectionner l'employé</h3>
          <select className="w-full p-3 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-amber-500 mb-6" value={selectedEmploye} onChange={handleSelectEmploye}>
            <option value="">Choisir un employé...</option>
            {employes.filter(e => e.Role !== 'admin' && e.Role !== 'observateur').map(emp => (
              <option key={emp.ID_Employes} value={emp.ID_Employes}>{emp.Prenom} {emp.Nom} ({emp.Matricule})</option>
            ))}
          </select>
          <button onClick={handleOpenModal} disabled={!selectedEmploye} className="w-full px-4 py-3 bg-amber-500 text-white rounded-xl hover:bg-amber-600 transition disabled:opacity-50 font-medium flex items-center justify-center gap-2">
            <Plus size={18} />Saisir un congé rétroactif
          </button>
        </div>
      </div>

      {showModal && selectedEmploye && (
        <RetroactiveModal 
          isOpen={showModal} 
          onClose={handleCloseModal} 
          onSuccess={handleSuccess}
          employeId={selectedEmploye}
          employeNom={selectedEmployeNom}
        />
      )}
    </div>
  );
}